"use strict";var e;exports.IKeyCodes=void 0,(e=exports.IKeyCodes||(exports.IKeyCodes={})).Enter="Enter",e.Space="Space",e.Esc="Escape";
//# sourceMappingURL=key-codes.enum.js.map
